
  import {Component, Prop, Vue} from "vue-property-decorator";

  @Component({})
  export default class CarNumber extends Vue {
    @Prop() carNumber: string;
    publicPath: string = process.env.VUE_APP_PUBLIC_URL;
    firstLetter = '';
    threeNumbers = '';
    twoLetters = '';
    countryCode = '';

    mounted() {
      this.prepareData();
    }

    clickAction() {
      this.$emit('clickNumber');
    }

    prepareData() {
      this.firstLetter = this.carNumber ? this.carNumber.substr(0, 1) : '';
      this.threeNumbers = this.carNumber ? this.carNumber.substr(1, 3) : '';
      this.twoLetters = this.carNumber ? this.carNumber.substr(4, 2) : '';
      this.countryCode = this.carNumber ? this.carNumber.substr(6, 3) : '';
    }
  }
